export default "__VITE_ASSET__8fe88f63__"